import { deleteDoc, doc } from 'firebase/firestore';
import { dataBase } from './firebaseConfig';
import { COLLECTIONS } from '../constants';

export const deleteFirebaseItem = async (
  id: string,
  collection: string = COLLECTIONS.listings,
) => {
  const itemRef = doc(dataBase, collection, id);
  await deleteDoc(itemRef);
};
